import React, { Component, Fragment } from "react";
import { shopContext } from "../contexts/aniplus";
import { withRouter } from "react-router-dom";

import axios from "axios";
// import Modal from "react-responsive-modal";

// import { ToastContainer, toast } from "react-toastify"; //토스트(toast)
// import { confirmAlert } from "react-confirm-alert"; //알럿창(alert confirm)
// import { AssignmentReturnedSharp } from "@material-ui/icons";

import PriceAgree1 from "./PriceAgree1";
import PriceAgree2 from "./PriceAgree2";
import PriceAgree3 from "./PriceAgree3";

class PriceAgree extends Component {
  state = {};
  componentDidMount = () => {
    this._getData();
  };
  _getData = async () => {
    const { loginId } = this.props;

    if (loginId === null || loginId === undefined || loginId === "") {
    } else {
      const result = await this._getDataApi();
      const intReturn = result.data[0].intReturn;
      const infoData = result.data[0].listData;

      if (intReturn === 0) {
        this.setState({
          infoData,
        });
      }
    }
  };
  _getDataApi = () => {
    const { apiUrl, loginId } = this.props;

    return axios
      .post(apiUrl + "/priceAgree", {
        params: {
          userid: loginId,
        },
      })
      .then((response) => response)
      .catch((error) => {
        alert("오류가 발생했습니다.");
      });
  };

  _onClose = () => {
    //alert(0)
    const { setAgreeShow } = this.props;
    setAgreeShow(false);
  };
  render() {
    const { infoData } = this.state;
    return (
      <Fragment>
        {infoData ? (
          infoData[0].billingGubun === "C" &&
          parseInt(infoData[0].price) > 0 &&
          parseInt(infoData[0].price) < 12900 ? (
            <PriceAgree1 infoData={infoData} />
          ) : infoData[0].billingGubun === "P" &&
            parseInt(infoData[0].price) > 500 &&
            parseInt(infoData[0].price) < 12900 ? ( //휴대폰 결제이면서 기존 청소년, 정기결제 이용자.
            <PriceAgree3 infoData={infoData} />
          ) : infoData[0].billingGubun === "P" &&
            parseInt(infoData[0].price) === 500 ? ( //휴대폰이면서 리뉴얼 무료 이용 결제자
            <div>
              <PriceAgree2 infoData={infoData} />
            </div>
          ) : null
        ) : null}
      </Fragment>
    );
  }
}

export default shopContext(withRouter(PriceAgree));
